export const PHONE_DISPLAY = "0413 700 692";
export const PHONE_TEL = "tel:0413700692";
export const BOOKING_URL =
  "https://book.servicem8.com/request_booking?uuid=8d7d3392-2308-4ad2-9c3b-237a6cdc096b";
export const WRITE_REVIEW_URL =
  "https://search.google.com/local/writereview?placeid=ChIJpRmOF3-dk2sRxp3v3EHV3b4";
export const READ_ALL_REVIEWS_URL =
  "https://search.google.com/local/reviews?placeid=ChIJpRmOF3-dk2sRxp3v3EHV3b4";

export const IMAGES = {
  heroSam:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/b31d77ba-4e55-4217-a6b2-97ba4f3de2e7/SWS+video+crop.jpg",
  heroBattery:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/72ba980f-be70-4d40-a649-e8d63d41b342/IMG_3971.jpg",
  towpro:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/586161fb-967e-47d1-823a-7e16c544b6ff/IMG_5774.JPEG",
  caravanPanel:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/eb8d0cb8-ec92-4e20-a7b6-9aa0ffe996fa/IMG_3841.JPEG",
  lithium:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/51721ceb-e058-4376-a34f-1bf0db764b96/IMG_5161.JPEG",
  airconUv:
    "https://images.squarespace-cdn.com/content/v1/66b69356a8bf6e767f3ba399/176e19bf-0a11-4a7b-ab57-dd03a02fdc5d/IMG_5980.JPEG",
};

export const MARQUEE_ITEMS = [
  "Batteries",
  "Alternators",
  "Starters",
  "Diagnostics",
  "Towing Setups",
  "Brake Controllers",
  "Air Conditioning",
  "Fit-outs",
];

export const REVIEWS = [
  {
    text: "Sam was excellent - got our reversing camera from car to caravan up and running - he came to us - so easy. Highly recommend him. Lovely guy.",
    author: "Google review",
  },
  {
    text: "The work he carried out was of a very high quality. Very easy to deal with and keen to please and he was half the price that I expected. Thanks Michael",
    author: "Michael",
  },
  {
    text: "I highly recommend Sam with any auto electrical work. Sam has completed several jobs for me now- A new AC condenser on a jeep GC and a new FOB key. Sam was honest, friendly, efficient and highly skilled.",
    author: "Google review",
  },
  {
    text: "Amazing service, genuine honest bloke, and competitive prices. Cannot reccomend Sam enough for speedy and precise work!",
    author: "Google review",
  },
  {
    text: "Thankyou to Sam, who came out on a Friday arvo to fix my broken down car. Much appreciated",
    author: "Google review",
  },
  {
    text: "Sam was so easy to deal with. Delivered a great service at a reasonable price. So good I have booked him to fit my Apple car play unit.",
    author: "Google review",
  },
];

export const FAQS = [
  {
    q: "Are you fully mobile?",
    a: "Yes — SWS is a mobile workshop. Sam comes to you across the Sunshine Coast, whether that's your home, your work, or wherever the vehicle is sitting.",
  },
  {
    q: "How do I get a quote?",
    a: "Call Sam on 0413 700 692 or send a booking request through the Book Now button. He'll talk through the issue with you and let you know what's involved before any work starts.",
  },
  {
    q: "What vehicles do you work on?",
    a: "All sorts — cars, 4x4s, caravans, trailers and light commercial vehicles. If it's got an electrical or air conditioning problem, give Sam a call.",
  },
  {
    q: "My aircon isn't cold — do I just need a re-gas?",
    a: "Maybe, but not always. If the system has a leak, a re-gas on its own won't last. Sam tests the system first and talks you through the repair options before re-gassing anything.",
  },
  {
    q: "How do I book?",
    a: "Two ways: call Sam directly on 0413 700 692, or hit Book Now to send a booking request through ServiceM8 and he'll get back to you to lock in a time.",
  },
];
